import styled from 'styled-components';
import React from 'react';

export const ContextMenuStyle = styled.div`
    margin: 0.2em;
    font-size: 12px;
    padding: 0.5em;
    &:hover {
        cursor: default;
        background: rgba(202, 234, 240, 0.5);
    }
`;

interface IPropsContextMenu {
    position: { x: number; y: number };
    closeCM?: Function;
    children: any;
}

export const ContextMenu: React.FC<IPropsContextMenu> = ({ position, closeCM, children }) => {
    return (
        <div
            style={{ width: '100%', height: '100%', position: 'absolute', top: 0, left: 0 }}
            onClick={() => {
                closeCM && closeCM();
            }}
            onMouseDown={(event: React.MouseEvent) => {
                if (event.button == 2) closeCM && closeCM();
            }}>
            <ContextMenuWrapper
                style={{
                    position: 'absolute',
                    width: '15em',
                    top: position.y,
                    left: position.x
                }}
                onClick={(e) => e.stopPropagation()}>
                {children}
            </ContextMenuWrapper>
        </div>
    );
};

export const ContextMenuNew: React.FC<IPropsContextMenu> = ({ position, closeCM, children }) => {
    return (
        <div
            style={{ width: '100%', height: '100%', top: 0, left: 0 }}
            onClick={() => {
                closeCM && closeCM();
            }}
            onMouseDown={(event: React.MouseEvent) => {
                if (event.button == 2) closeCM && closeCM();
            }}>
            <ContextMenuWrapper
                style={{
                    position: 'absolute',
                    width: '15em',
                    top: position.y,
                    left: position.x
                }}
                onClick={(e) => e.stopPropagation()}>
                {children}
            </ContextMenuWrapper>
        </div>
    );
};
const ContextMenuWrapper = styled.div`
    background: #ffffff;
    border: 0.2px solid #8b8b8b;
    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
`;
